import React from 'react';
import {ColoredTypography, Section} from './CardStyles';
import {COLORS} from '@fupa/fupa-uikit';
import FreeTrialButton from '../components/FreeTrialButton';
import ContentImage from '../components/ContentImage';
import styled from 'styled-components';
import {createVariants} from '../motions/MotionVariants';
import {motion} from 'framer-motion';

const ContainerTextAndImage = styled('div')`
  display: flex;
  flex-direction: row;
  padding: 0 2rem;
  align-items: center;
  max-width: 1200px;

  @media all and (max-width: 800px) {
    flex-direction: column;
  }
`;

const TextContainer = styled(motion.div)`
  text-align: left;
  width: 80%;

  @media all and (max-width: 800px) {
    width: 100%;
  }
`;

const IntroductionCard = () => {
  const variant = createVariants('left');
  return (
    <Section backgroundColor={COLORS.fupaPrimary} primaryGradient>
      <ContainerTextAndImage>
        <TextContainer
          initial='offscreen'
          whileInView='onscreen'
          variants={variant}
          viewport={{amount: 0.5, once: true}}>
          <ColoredTypography variant='headline2' component='h2' color={COLORS.white}>
            Widgets, die sich auf deine Website anpassen
          </ColoredTypography>
          <ColoredTypography variant='subheading' component='p' color={COLORS.white}>
            Responsive, komplett individualisierbare Styles und Daten saisonübergreifend ohne Neukonfiguration:
            <br /> Die Widgets von FuPa ermöglichen dir eine schnelle und vor allem einfache Erweiterung deiner eigenen
            Website. Im Moment bieten wir Team Widgets mit fünf verschiedenen Ansichten an.
          </ColoredTypography>
          <ColoredTypography variant='subheading' component='p' color={COLORS.white}>
            Sieh dir unsere neuen Widgets an und teste unseren neuen Widget-Builder — auch ohne Anmeldung.
          </ColoredTypography>
          <br />
          <FreeTrialButton />
        </TextContainer>
        <ContentImage
          comesInViewFrom={'right'}
          lazy={true}
          imgHeight={300}
          imgWidth={516}
          imgAlt='Darstellung der FuPa Widgets auf Webseite'
          imgSrc={'/landingpage_usp_styles'}
        />
      </ContainerTextAndImage>
    </Section>
  );
};

export default IntroductionCard;
